<ac-form *ngIf="dialogConfig.ready" [formSettings]="dialogConfig.formSettings">
    <network-tenant-region-selection [model]="tenant"
                                     (acTenantChanged)="tenant.tenantId = $event"
                                     [isEdit]="false"
                                     [tenants]="tenants"
                                     [overrideSystemViewMode]="true"
                                     [showRegion]="false">
    </network-tenant-region-selection>
</ac-form>
